export const FREE_COUPON_CODE = ['FREE5MINUTES'];